import styled from 'styled-components';

const GalleryArrow = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    cursor: pointer;
    border: 1px solid var(--luft-secondary-darker);
    ${({ left }) => left && 'left: 24px'};
    ${({ right }) => right && 'right: 24px'};

    &:hover {
      opacity: 0.7;
    }

    & i {
      color: var(--luft-secondary-darker);           
      font-size: 20px;
      font-weight: bold;
    }
`;

export const GalleryArrowLeft = styled(GalleryArrow)`
  position: absolute;
  top: 55px;
  right: 230px;
  filter: ${({prevArrowActive}) => prevArrowActive ? 'none' : 'grayscale(100%) opacity(50%)'};
`;

export const GalleryArrowRight = styled(GalleryArrow)`
  position: absolute;
  top: 55px;
  right: 190px;
  filter: ${({nextArrowActive}) => nextArrowActive ? 'none' : 'grayscale(100%) opacity(50%)'};
`;
